import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import './teambox.css';
const TeamBox = () => {
    const name = (text) => setIsName(text);
    const briefInfo = (text) => setIsInfo(text);
    const desig = (text) => setIsDesig(text);
    const [imgcolor_1, setimgColor_1] = useState('rgb(32,32,32,0.9)')
    const [imgcolor_2, setimgColor_2] = useState('#F3F3F3')
    const [imgcolor_3, setimgColor_3] = useState('#F3F3F3')
    const [imgcolor_4, setimgColor_4] = useState('#F3F3F3')
    const [isName, setIsName] = useState('Shariq Ahmed');
    const [isdesig, setIsDesig] = useState('Founder & CEO of Untouched');
    const [isinfo, setIsInfo] = useState('Being a leader he found an opportunity in uncertainty in COVID time. He converted a problem into a sustainable and scalable solution through technology which creates employment, profitability, cleanliness and hygiene in the community.');

    return (<Box
        sx={theme => ({
            [theme.breakpoints.up('sm')]: { margin: '5% 0% 0% 0%', height: '58vh', width: '100vw', maxWidth: '100%', backgroundColor: '#F3F3F3' },
            [theme.breakpoints.between('0', '600')]: { margin: '5% 0% 20% 0%', height: '65vh', width: '100vw', maxWidth: '100%', backgroundColor: '#F3F3F3' }
        })}

    >
        <div className="story__container">
            <div className="our-team">
                <p>Our Team</p>
            </div>
            <div className="imgsec">

                <img id='img_a' style={{ borderColor: imgcolor_1, borderWidth: 3, borderStyle: 'solid' }} onMouseEnter={() => { name("Shariq Ahmed"); desig('Founder & CEO of Untouched'); briefInfo('Being a leader he found an opportunity in uncertainty in COVID time. He converted a problem into a sustainable and scalable solution through technology which creates employment, profitability, cleanliness and hygiene in the community.'); setimgColor_1('rgb(32,32,32,0.9)'); setimgColor_2('#F3F3F3'); setimgColor_3('#F3F3F3'); setimgColor_4('#F3F3F3') }} src="images/team/shariq.jpg" alt="img1" />
                {/* <img id ='img_b' style={{borderColor:imgcolor_2,borderWidth:3,borderStyle:'solid'}} onMouseEnter={()=> {name("Deepti Ayyagari");desig('Product Scientist'); briefInfo("A research scholar from IIT Indore, initially invested in this project later preorder it and then joined the team. Currently, she is supporting product development in electronics and other technical aspects.");setimgColor_1('#F3F3F3');setimgColor_2('rgb(32,32,32,0.9)');setimgColor_3('#F3F3F3');setimgColor_4('#F3F3F3')}} src="images/team/deepti_1.jpg" alt="img2" /> */}
                {/* <img id ='img_c' style={{borderColor:imgcolor_3,borderWidth:3,borderStyle:'solid'}} onMouseEnter={()=> {name('Rukesh Lingayat');desig('Software developer Intern') ;briefInfo("Student who is passionate about developing software and provides both creativity and robustness to the frontend and backend development.");setimgColor_1('#F3F3F3');setimgColor_2('#F3F3F3');setimgColor_3('rgb(32,32,32,0.9)');setimgColor_4('#F3F3F3')}} src="images/team/rukesh.jpg" alt="img3" /> */}
                <img id='img_d' style={{ borderColor: imgcolor_4, borderWidth: 3, borderStyle: 'solid' }} onMouseEnter={() => { name('Sushanth Gudepu'); desig('Co-Founder & Product Developer'); briefInfo("Sushanth joined as an intern and has progressed to the position of Product Developer (Mechanical), where he is responsible for product modelling, harness, assembly, drawing, and testing."); setimgColor_1('#F3F3F3'); setimgColor_2('#F3F3F3'); setimgColor_3('#F3F3F3'); setimgColor_4('rgb(32,32,32,0.9)') }} src="images/team/sushanth_1.jpg" alt="img4" />

                <div className="mid-story-boundary"></div>
                <div className="mid-story-boundary-hor"></div>
                <div className="team_sec">

                    <div className="part">
                        <div className='isname'>{isName}</div>

                        <div className='isdesig'>{isdesig}</div>
                        <p></p>
                        <div className="isinfo">{isinfo}</div>
                    </div>

                </div>

            </div>
        </div>
    </Box>

    );
}

export default TeamBox;